export default {
  namespaced: true,
  state: () => ({
    busy: false
  }),
  mutations: {
    SET_BUSY(state, busy) {
      state.busy = busy
    }
  },
  actions: {
    panelBusy({ commit }) {
      commit('SET_BUSY', true)
    },
    panelUnnocupied({ commit }) {
      commit('SET_BUSY', false)
    }
  },
  getters: {
    isBusy(state) {
      return state.busy
    }
  }
}
